import {
  CPTSlabForManualOption,
  CPTSlabManualDisplay,
} from "../../../../views/Orders/enums";

export const MANUAL_CPT_SLAB_OPTIONS = [
  {
    value: CPTSlabForManualOption.INSTANT_DELIVERY,
    label: CPTSlabManualDisplay[CPTSlabForManualOption.INSTANT_DELIVERY],
    icon: "🏎️",
  },
  {
    value: CPTSlabForManualOption.STANDARD_DELIVERY,
    label: CPTSlabManualDisplay[CPTSlabForManualOption.STANDARD_DELIVERY],
    icon: "🚚",
  },
  {
    value: CPTSlabForManualOption.SELF_PICKUP,
    label: CPTSlabManualDisplay[CPTSlabForManualOption.SELF_PICKUP],
    icon: "🚶",
  },
];
